import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import style from "./carrusel.module.css";
import EventoJulio52025 from "../../assets/carrusel/2025/julio52025.jpg";
import EventoJulio42025 from "../../assets/carrusel/2025/julio42025.jpg";
import EventoJulio32025 from "../../assets/carrusel/2025/julio32025.jpg";
import EventoJulio22025 from "../../assets/carrusel/2025/julio22025.jpg";
import EventoJulio12025 from "../../assets/carrusel/2025/julio12025.jpg";
import EventoJunio32025 from "../../assets/carrusel/2025/EventoJunio32025.jpg";
import EventoJunio22025 from "../../assets/carrusel/2025/EventoJunio22025.jpg";
import EventoJunio12025 from "../../assets/carrusel/2025/EventoJunio12025.jpg";
import EventoMayo22025 from "../../assets/carrusel/2025/EventoMayo22025.jpg";
import EventoMayo12025 from "../../assets/carrusel/2025/EventoMayo12025.jpg";
import EventoMArzo42025 from "../../assets/carrusel/2025/Marzo4.jpg";
import EventoMarzo32025 from "../../assets/carrusel/2025/Marzo3.jpg";
import EventoMarzo22025 from "../../assets/carrusel/2025/marzo2.jpg";
import EventoMarzo2025 from "../../assets/carrusel/2025/marzo.jpg";
import EventoNoviembre from "../../assets/carrusel/noviembre.jpg";
import EventoOctubre2 from "../../assets/carrusel/octubre.jpg";
import EventoOctubre from "../../assets/carrusel/octubre2.jpg";
import EventoSeptiembre2 from "../../assets/carrusel/septiembre2.jpg";
import EventoSeptiembre from "../../assets/carrusel/septiembre.png";
import EventoAgosto from "../../assets/carrusel/agosto.png";
import EventoJulio from "../../assets/carrusel/julio.jpg";
import EventoJunio from "../../assets/carrusel/junio.png";
import EventoMayo from "../../assets/carrusel/mayo.jpg";
import EventoAbril from "../../assets/carrusel/abril.jpg";
import EventoMarzo from "../../assets/carrusel/marzo.jpg";
import EventoFebrero from "../../assets/carrusel/febrero.jpg";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";

type ArrowProps = {
  onClick: () => void | any;
};

const NextArrow: React.FC<ArrowProps> = (props) => {
  const { onClick } = props;
  return (
    <div className={style.buttond} onClick={onClick}>
      <KeyboardDoubleArrowRightIcon />
    </div>
  );
};

const PrevArrow: React.FC<ArrowProps> = (props) => {
  const { onClick } = props;
  return (
    <div className={style.buttond} onClick={onClick}>
      <KeyboardDoubleArrowLeftIcon />
    </div>
  );
};

const Carrusel: React.FC = () => {
  useEffect(() => {
    const slider = document.querySelector(".slick-slider");
    if (slider) {
      (slider as HTMLElement).style.display = "flex";
      (slider as HTMLElement).style.flexDirection = "row";
      (slider as HTMLElement).style.alignItems = "center";
      (slider as HTMLElement).style.margin = "0 auto";
      (slider as HTMLElement).style.backgroundColor = "#ffffff";
    }
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    fade: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <NextArrow onClick={() => {}} />,
    prevArrow: <PrevArrow onClick={() => {}} />,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          dots: true,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          fade: false,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 3000,
        },
      },
    ],
  };

  return (
    <main className={style.SliderMaster}>
      <div className={style.TittleEventos}>Eventos</div>
      <Slider {...settings}>
        {/*Julio 2025 v5 */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoJulio52025}
            />
          </div>
          <h1 className={style.TextEvent}>Conversatorio LiberTienda</h1>
          <h5 className={style.FechaEvent}>Fecha: Julio del 2025</h5>
          <p className={style.TextImg}>
            En juntanza con otras organizaciones convocamos el exitoso
            conversatorio sobre la vida y obra de Ignacio Torres Giraldo,
            historiador, líder sindical y ensayista, en la librería
            independiente LiberTienda.
          </p>
        </div>
        {/*Julio 2025 v4 */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoJulio42025}
            />
          </div>
          <h1 className={style.TextEvent}>Comunidad de Brisas de la Paz</h1>
          <h5 className={style.FechaEvent}>Fecha: Julio del 2025</h5>
          <p className={style.TextImg}>
            Nos solidarizamos con la comunidad de Brisas de la Paz, asentamiento
            de desarrollo humano incompleto que padeció la perdida de 12 hogares
            tras un incendio, los habitantes nos expusieron diversas
            problemáticas entre y solicitudes.
          </p>
        </div>
        {/*Julio 2025 v3 */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoJulio32025}
            />
          </div>
          <h1 className={style.TextEvent}>Fundación Casa de la Paz</h1>
          <h5 className={style.FechaEvent}>Fecha: Julio del 2025</h5>
          <p className={style.TextImg}>
            En la comuna 1 llegamos hasta la Fundación Casa de la Paz, donde en
            medio de una kermes que busca recolectar fondos para el mejoramiento
            de sus instalaciones, con música, rica comida y bingos escuchamos a
            la comunidad.
          </p>
        </div>
        {/*Julio 2025 v2 */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoJulio22025}
            />
          </div>
          <h1 className={style.TextEvent}>
            Proyecto de Acuerdo Catedra Ambiental Escolar PRAE
          </h1>
          <h5 className={style.FechaEvent}>Fecha: Julio del 2025</h5>
          <p className={style.TextImg}>
            Estamos trabajando con la buena disposición técnica de la Secretaría
            de Educación, en reunión con la líder de esta cartera, Sara Rodas,
            planteamos lineamientos para la implementación del Proyecto de
            Acuerdo Catedra Ambiental Escolar PRAE para fortalecer procesos
            ambientales en instituciones oficiales de Cali.
          </p>
        </div>
        {/*Julio 2025 v1 */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoJulio12025}
            />
          </div>
          <h1 className={style.TextEvent}>
            Encuentros Territoriales Ambientales
          </h1>
          <h5 className={style.FechaEvent}>Fecha: Julio del 2025</h5>
          <p className={style.TextImg}>
            Arrancamos con toda participando de los Encuentros Territoriales
            Ambientales en el Valle del Cauca, una apuesta del Partido Alianza
            Verde para escuchar, construir y actuar desde la Ética Política, la
            Justicia Ambiental y la lucha por la Democracia dentro de nuestros
            territorios.
          </p>
        </div>
        {/*Junio 05 2025 v3 */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoJunio32025}
            />
          </div>
          <h1 className={style.TextEvent}>Mercado Campesino</h1>
          <h5 className={style.FechaEvent}>Fecha: Junio 05 del 2025</h5>
          <p className={style.TextImg}>
            Desde El Cambio es con vos, trabajamos por la dignidad y el
            reconocimiento de la población campesina en Cali. Es un paso gigante
            en el reconocimiento de los derechos a esta importante población.
          </p>
        </div>
        {/*Junio 05 2025 v2 */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoJunio22025}
            />
          </div>
          <h1 className={style.TextEvent}>Mercado Campesino</h1>
          <h5 className={style.FechaEvent}>Fecha: Junio 05 del 2025</h5>
          <p className={style.TextImg}>
            Nuestros campesinos trajeron el campo al Concejo de Cali,
            compartimos una jornada maravillosa donde compartimos experiencias y
            emprendimientos verdes.
          </p>
        </div>
        {/*Junio 05 2025 v1 */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoJunio12025}
            />
          </div>
          <h1 className={style.TextEvent}>Radicación de Proyectos</h1>
          <h5 className={style.FechaEvent}>Fecha: Junio 5 del 2025</h5>
          <p className={style.TextImg}>
            En medio de la conmemoración del Día Mundial del Medio Ambiente
            radicamos dos proyectos de acuerdo llamados Día de la Población
            Campesina y Cátedra Ambiental, proyectos que promueven la
            sostenibilidad y educación ambiental.
          </p>
        </div>
        {/*Mayo 28 2025 */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoMayo22025}
            />
          </div>
          <h1 className={style.TextEvent}>La consulta popular es Democracia</h1>
          <h5 className={style.FechaEvent}>Fecha: Mayo 28 del 2025</h5>
          <p className={style.TextImg}>
            Nos movilizamos en apoyo a las reformas laborales por los
            trabajadores colombianos, en las calles ejercimos nuestro derecho a
            la manifestación pacífica.
          </p>
        </div>
        {/*Mayo 09 2025 */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoMayo12025}
            />
          </div>
          <h1 className={style.TextEvent}>Conversatorio Partido Verde</h1>
          <h5 className={style.FechaEvent}>Fecha: Mayo 09 del 2025</h5>
          <p className={style.TextImg}>
            En la plazoleta Jairo Varela nos reunimos con cientos de personas en
            respaldo a la Consulta Popular, conformamos equipos pedagógicos en
            pro de la recuperación derechos laborales.
          </p>
        </div>
        {/* Marzo4 2025 */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoMArzo42025}
            />
          </div>
          <h1 className={style.TextEvent}>Acompañamiento a comerciantes </h1>
          <h5 className={style.FechaEvent}>Fecha: Marzo 2025</h5>
          <p className={style.TextImg}>
            Acompañamiento a comerciantes nocturnos de la comuna 16, barrio
            Mariano Ramos, junto a la Secretaría de Seguridad y Justicia.
          </p>
        </div>
        {/* Marzo3 2025 */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoMarzo32025}
            />
          </div>
          <h1 className={style.TextEvent}>
            Recorrido por el corregimiento de Pance{" "}
          </h1>
          <h5 className={style.FechaEvent}>Fecha: Marzo 2025</h5>
          <p className={style.TextImg}>
            Realizamos un recorrido por el corregimiento de Pance junto a la
            comunidad indígena Nasa Pance, en donde abordamos los lineamientos a
            tener en cuenta para el Plan de Ordenamiento Territorial.
          </p>
        </div>
        {/* Marzo1 2025 */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoMarzo2025}
            />
          </div>
          <h1 className={style.TextEvent}>#ConsultaPopularYa </h1>
          <h5 className={style.FechaEvent}>Fecha: Marzo 18 de 2025</h5>
          <p className={style.TextImg}>
            Participamos en la Gran Movilización por las Reformas Sociales del
            cambio y rechazamos el hundimiento de la Reforma Laboral. ¡La
            democracia se ejerce en las calles! Estas reformas buscan mejorar la
            vida de millones, pero solo ocho congresistas archivaron la
            propuesta.
          </p>
        </div>
        {/* Marzo2 2025 */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoMarzo22025}
            />
          </div>
          <h1 className={style.TextEvent}>Circulo de Mujeres</h1>
          <h5 className={style.FechaEvent}>Fecha: Marzo 16 de 2025</h5>
          <p className={style.TextImg}>
            Llevamos a cabo el primer círculo de mujeres Sanando tu ser, un
            espacio de diálogo y reflexión femenina. Este encuentro permitió
            liberar cargas y reconocer a las mujeres como agentes de cambio
            social. ¡Cuando una mujer avanza, avanzamos todos!
          </p>
        </div>
        {/* Noviembre */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoNoviembre}
            />
          </div>
          <h1 className={style.TextEvent}>Territorios </h1>
          <h5 className={style.FechaEvent}>Fecha: Noviembre 11 de 2024</h5>
          <p className={style.TextImg}>
            En Terrón Colorado, comuna 1 con la comunidad rendimos cuentas de
            nuestra gestión dentro del Concejo de Cali, además escuchamos las
            problemáticas del sector como mejora vial y programas de atención a
            primera infancia y adultos mayores.
          </p>
        </div>
        {/* Octubre2 */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoOctubre2}
            />
          </div>
          <h1 className={style.TextEvent}>Encuentro Partido Verde </h1>
          <h5 className={style.FechaEvent}>Fecha: Octubre 25 de 2024</h5>
          <p className={style.TextImg}>
            En el Encuentro Nacional de Dirigentes del Partido Alianza Verde, en
            medio de la COP-16 dialogamos en aras de priorizar la agenda
            ambiental del partido que integre aspectos ecológicos y
            sociopolíticos.
          </p>
        </div>
        {/* Octubre */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoOctubre}
            />
          </div>
          <h1 className={style.TextEvent}>Salida zona verde COP 16 </h1>
          <h5 className={style.FechaEvent}>Fecha: Octubre 19 de 2024</h5>
          <p className={style.TextImg}>
            Junto a los concejales recorrimos la zona verde de la COP-16, “la
            zona de la gente”, pudimos evidenciar las condiciones en que
            estuvieron los expositores y el montaje general que compuso la ruta.
          </p>
        </div>
        {/* Septiembre2 */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoSeptiembre}
              alt="Rodrigo Salazar"
              src={EventoSeptiembre2}
            />
          </div>
          <h1 className={style.TextEvent}>Animaltón </h1>
          <h5 className={style.FechaEvent}>Fecha: Septiembre 29 de 2024</h5>
          <p className={style.TextImg}>
            Apoyamos la gran jornada Animaltón, dona de corazón, un espacio
            donde se recaudó alimento y juguetes para cientos de seres
            sintientes necesitados y asegurar su bienestar.
          </p>
        </div>
        {/* Septiembre */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoSeptiembre}
              alt="Rodrigo Salazar"
              src={EventoSeptiembre}
            />
          </div>
          <h1 className={style.TextEvent}>Visita bulevar de Oriente </h1>
          <h5 className={style.FechaEvent}>Fecha: Septiembre 2 de 2024</h5>
          <p className={style.TextImg}>
            Llegamos al Bulevar de Oriente donde adelantamos una visita para ver
            el estado actual de dicho espacio y determinar si necesita mayor
            mantenimiento por parte de la Administración.
          </p>
        </div>
        {/* Agosto */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoAgosto}
              alt="Rodrigo Salazar"
              src={EventoAgosto}
            />
          </div>
          <h1 className={style.TextEvent}>Petronio Álvarez</h1>
          <h5 className={style.FechaEvent}>Fecha: Agosto 14 de 2024</h5>
          <p className={style.TextImg}>
            Al ritmo de la marimba, con los sabores de la gastronomía y las más
            deliciosas bebidas del Pacífico colombiano disfrutamos del
            espectacular festival de música Petronio Alvarez, que demuestra ser
            un espacio de encuentro ciudadano y de reivindicación de la cultura
            afro.
          </p>
        </div>
        {/* Julio */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoJulio}
              alt="Rodrigo Salazar"
              src={EventoJulio}
            />
          </div>
          <h1 className={style.TextEvent}>Visita Parque Cristo Rey</h1>
          <h5 className={style.FechaEvent}>Fecha: Julio 27 de 2024</h5>
          <p className={style.TextImg}>
            En el marco del cumpleaños 488 de Cali junto al alcalde realizamos
            visita técnica al Parque Integral Cristo Rey, evidéncianos el avance
            de esta magnífica obra movilizadora que sin duda será la uno de los
            puntos turísticos favoritos para propios y visitantes.
          </p>
        </div>
        {/* Junio */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoJunio}
              alt="Rodrigo Salazar"
              src={EventoJunio}
            />
          </div>
          <h1 className={style.TextEvent}>Visita a vereda el Saladito</h1>
          <h5 className={style.FechaEvent}>Fecha: Junio 30 de 2024</h5>
          <p className={style.TextImg}>
            En el corregimiento El Saladito estuvimos presentes en la primera
            celebración del día del campesino, junto a habitantes y líderes del
            sector. Compartimos una jornada de música, emprendimientos verdes y
            la alegría de la gente.
          </p>
        </div>
        {/* Mayo */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoMayo}
              alt="Rodrigo Salazar"
              src={EventoMayo}
            />
          </div>
          <h1 className={style.TextEvent}>Gran jornada del día del trabajo</h1>
          <h5 className={style.FechaEvent}>Fecha: Mayo 01 de 2024</h5>
          <p className={style.TextImg}>
            Con el #ElCambioEsConVos nos movilizamos en las calles junto a miles
            de trabajadores para seguir apoyando las reformas del cambio del
            gobierno nacional. Toda transformación solo se alcanza si la gente
            las conquista en la calle.
          </p>
        </div>
        {/* Abril */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoAbril}
              alt="Rodrigo Salazar"
              src={EventoAbril}
            />
          </div>
          <h1 className={style.TextEvent}>Día Movilización por las Víctimas</h1>
          <h5 className={style.FechaEvent}>Fecha: Abril 09 de 2024</h5>
          <p className={style.TextImg}>
            En el Día Nacional de la Memoria y Solidaridad por las Víctimas,
            junto a diversas organizaciones sociales nos movilizamos en las
            calles por las víctimas, la paz y su reparación, al igual que en
            apoyo a las reformas del cambio.
          </p>
        </div>
        {/* Marzo */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoMarzo}
              alt="Rodrigo Salazar"
              src={EventoMarzo}
            />
          </div>

          <h1 className={style.TextEvent}>Limpiatón del Río Cali</h1>
          <h5 className={style.FechaEvent}>Fecha: Marzo 17 de 2024</h5>
          <p className={style.TextImg}>
            Con el objetivo de conmemorar en marzo el mes de acción por los
            ríos, junto con el colectivo El Cambio es con Vos, desarrollamos una
            jornada de limpieza en el río Cali, en la que con la valiosa ayuda
            de los asistentes se logró despejar de las orillas un gran número de
            residuos sólidos. <br />
            <br />
            Hicimos un llamado a la Alcaldía de Cali y al DAGMA y fortalecer
            acciones de control y mitigación de residuos sobre nuestros ríos.
          </p>
        </div>
        {/* Febrero */}
        <div className={style.Matter}>
          <div className={style.MatterContent}>
            <img
              className={style.EventoFebrero}
              alt="Rodrigo Salazar"
              src={EventoFebrero}
            />
          </div>
          <h1 className={style.TextEvent}>Jornada Nacional por la paz</h1>
          <h5 className={style.FechaEvent}>Fecha: Febrero 21 de 2024</h5>
          <p className={style.TextImg}>
            En el marco de la gran Jornada Nacional por la Paz y la Vida,
            llevada a cabo en el hemiciclo del Concejo de Cali, se desarrollaron
            diversos actos culturales propios de la región pacífica y una
            liturgia en donde se resaltó la necesidad de acciones que logren
            frenar la violencia en Colombia.
          </p>
        </div>
      </Slider>
    </main>
  );
};

export default Carrusel;
